import { getBaseTitleFromEnv } from '@/app/parseEnv';

export default function setTitle(title, { isRoot = false } = {}) {
  const BASE_TITLE = getBaseTitleFromEnv();
  const base = BASE_TITLE ? `— ${BASE_TITLE}` : '';
  document.title = isRoot ? BASE_TITLE : `${title} ${base}`;
}
